import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BackAndNextAppStyles } from './Style';
import { IconButton } from '@mui/material';
import { XSSpaceBetween } from 'styles/GlobalStyle';

const BackAndNextApp = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const [canGoBack, setCanGoBack] = useState(false);
    const [canGoForward, setCanGoForward] = useState(false);

    // בדיקה אם אנחנו בתוך אפליקציה (PWA)
    const isStandalone = 
        window.matchMedia('(display-mode: standalone)').matches || 
        (window.navigator).standalone === true;

    useEffect(() => {
        const historyState = window.history.state;
        
        if (historyState && typeof historyState.idx === 'number') {
            const currentIndex = historyState.idx;

            // 1. כפתור אחורה: פשוט ואמין
            setCanGoBack(currentIndex > 0);

            // 2. כפתור קדימה: הפתרון המדויק
            // אנחנו בודקים אם האינדקס הנוכחי קטן מהאינדקס הכי גבוה שהגענו אליו ב-Session
            const maxIndex = Number(sessionStorage.getItem('maxHistoryIdx') || 0);
            
            if (currentIndex > maxIndex) {
                sessionStorage.setItem('maxHistoryIdx', currentIndex.toString());
            }
            
            setCanGoForward(currentIndex < maxIndex);
        }
    }, [location]);

    // אם אנחנו בדפדפן רגיל - לא מציגים את הקומפוננטה
    if (!isStandalone) return null;

    return (
        <BackAndNextAppStyles>
            <div className='app-buttons'>
                <IconButton disabled={!canGoBack} onClick={() => navigate(-1)}>
                    <i className={`fa-solid fa-arrow-right app-icon ${!canGoBack ? 'disabled-icon' : ''}`} />
                </IconButton>
                
                <XSSpaceBetween />
                
                <IconButton disabled={!canGoForward} onClick={() => navigate(1)}>
                    <i className={`fa-solid fa-arrow-left app-icon ${!canGoForward ? 'disabled-icon' : ''}`} />
                </IconButton>
            </div>
            {/* כפתור רענון תמיד פעיל */}
            <IconButton onClick={() => window.location.reload()}>
                <i className="fa-solid fa-arrow-rotate-right app-icon"></i>
            </IconButton>
        </BackAndNextAppStyles>
    );
};

export default BackAndNextApp